(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
 const excludedHandle = 'navidium-shipping-protection';
const maxProducts = 5;

const productRecommendationsSection = document.querySelector('.product-recommendations');

const handleIntersection = (entries, observer) => {
  if (!entries[0].isIntersecting) return;

  observer.unobserve(productRecommendationsSection);

  const rawUrl = productRecommendationsSection.dataset.url;
  const url = new URL(rawUrl, window.location.origin);
  url.searchParams.set('limit', '5'); 

  fetch(url)
    .then(response => response.text())
    .then(text => {
      const tempWrapper = document.createElement('div');
      tempWrapper.innerHTML = text;

      const recommendations = tempWrapper.querySelector('.product-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        const productLinks = recommendations.querySelectorAll('a[href*="/products/"]');
        let shownCount = 0;
        const seenHandles = new Set();

        productLinks.forEach(link => {
          const href = link.getAttribute('href');
          const card = link.closest('.grid__item, .product-item, .card');

          if (!card || seenHandles.has(href)) return;

          seenHandles.add(href);

          const handle = href.split('/products/')[1].split('/')[0];
          console.log('Found product handle:', handle);

          const shouldExclude = handle === excludedHandle;
          const shouldLimit = shownCount >= maxProducts;

          if (shouldExclude) {
            console.log(`Excluding product: ${handle}`);
            card.remove();
          } else if (shouldLimit) {
            card.remove();
          } else {
            shownCount++;
          }
        });

        console.log('Total products shown:', shownCount);

        productRecommendationsSection.innerHTML = recommendations.innerHTML;

        if (window.yotpo?.initWidgets) {
          window.yotpo.initWidgets();
        }
      }
    })
    .catch(e => {
      console.error('Error loading recommendations:', e);
    });
};

const observer = new IntersectionObserver(handleIntersection, {
  rootMargin: '0px 0px 200px 0px'
});

observer.observe(productRecommendationsSection);


  } catch(e) { console.error(e); }
})();
})();
